import { Trnlist } from "./Trnlist";

export class Stmtrs{
    constructor(){}

    Acctid: string = null;
    Trnlist: Trnlist[] = null;

    Deserialize(input:any){
        this.Acctid = input.acctid._text;

        if (input.trnlist!=null){
            this.Trnlist=[];
            input.trnlist.stmttrn.forEach(Item => {
                return this.Trnlist.push(new Trnlist().Deserialize(Item))
            });
        }

        return this;
    }
}